@use "../zr-css-icon/zr-css-icon.scss" as i;

// local component name
$component: 'zr-rating-stars';

:host {
    display: inline-block;
    line-height: 0;
}

// Bind placeholders to classes
.#{$component}__icon-star {
    @include i.get-icon-only(star-outline);

    &--filled {
        @include i.get-icon-only(star-gold);
    }

    &--half-filled {
        @include i.get-icon-only(star-half-filled);
    }

    &,
    &--filled,
    &--half-filled {
        &::before {
            width: 16px;
            height: 16px;
        }
    }

    &--filled,
    &--half-filled {
        &::before {
            background-color: #FA9600;
        }
    }
}
